import { Hub } from 'aws-amplify'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import AccessDeniedPNG from '../assets/images/illustrations/access-expired.png'
import trackEvents from '../constants/track-events'
import { createSupportEmailWithLogs } from '../helpers/log-collector'
import SpaceChoiceList from './space-choice-list'
const { version } = require('../../package.json')

// `spaces` sind die *anderen* EMPLOYEE-Spaces des Users. Sind welche da, ist der
// AccessDenied keine Sackgasse mehr: der User sitzt dann in einem formal
// gültigen, aber unbezahlten Account (typisch: Alt-Account aus der Zeit vor
// einer Migration) und kann zurückwechseln. Ohne weitere Spaces bleibt der
// Screen exakt wie vorher — das ist der legitime Fall des abgelaufenen Kunden.
const AccessDenied = ({ spaces, userId, restartDashboard }) => {
  const { t } = useTranslation()

  const hasFallbackSpaces = !!spaces.length && !!userId && !!restartDashboard

  return (
    <div className='flex flex-col items-center p-16'>
      <img className='h-80 w-80 object-contain' src={AccessDeniedPNG} alt='' />
      <div className='px-6 py-4 sm:px-6 sm:py-8 lg:px-8'>
        <div className='mx-auto max-w-2xl text-center'>
          <h2 className='text-lg font-medium text-gray-900'>
            {t(
              hasFallbackSpaces
                ? 'access_denied.switch_space_title'
                : 'access_denied.title'
            )}
          </h2>
          <p className='mx-auto mt-2 max-w-xl text-sm text-gray-700'>
            {t(
              hasFallbackSpaces
                ? 'access_denied.switch_space_description'
                : 'access_denied.description'
            )}
          </p>

          {hasFallbackSpaces && (
            <SpaceChoiceList
              spaces={spaces}
              userId={userId}
              restartDashboard={restartDashboard}
              trackingEvent={trackEvents.CLICK_CHANGE_LOCATION_ACCESS_DENIED}
            />
          )}

          <div className='mt-6 flex items-center justify-center gap-x-6'>
            <a
              href={createSupportEmailWithLogs(
                'Aivy-Dashboard - Fehlende Berechtigung',
                `Ich habe keine Berechtigung für das Dashboard.\n\nURL: ${window.location.href}\nZeitpunkt: ${new Date().toISOString()}`
              )}
              className='text-sm font-semibold leading-6 text-gray-900'
            >
              {t('access_denied.support_action')}
            </a>
            <button
              onClick={() => Hub.dispatch('auth', { event: 'signOut' })}
              className='text-sm font-semibold leading-6 text-gray-900'
            >
              {t('access_denied.logout_action')}
            </button>
          </div>
        </div>
      </div>
      <div className='mt-4 text-center'>
        <span className='text-center text-xs italic text-gray-700'>{`v${version}`}</span>
      </div>
    </div>
  )
}

AccessDenied.propTypes = {
  spaces: PropTypes.array,
  userId: PropTypes.string,
  restartDashboard: PropTypes.func
}

AccessDenied.defaultProps = {
  spaces: [],
  userId: null,
  restartDashboard: null
}

export default AccessDenied
